import axios from "../request";

//上限配置列表
export function getMakeConfig() {
  return axios.request({
    url: "api/MakeConfig",
    method: "get"
  });
}

//修改上限配置
export function UpdateMake(id, data) {
  return axios.request({
    url: "api/MakeConfig/"+id,
    method: "put",
    data: data
  });
}
